import React from "react"
import "../../styles/history.css";
import gilcaImg from "../../img/gilca/img1024.png";

const History: React.FC = () => {
    return (
        <>
            <div className="color_history_about">
                <div className="zoom_history_about">
                    <div className="about_text_gilca">
                        <h2 className="about_name_clinic">Dra. Gilca Lucena Kortmann</h2>
                    </div>
                    <div className="history_clinic">
                        <div className="history_about">
                            <p className="clinica_texto_about">
                                <h2 className="about_name"></h2>
                                <br />
                                <br />
                                Fundada e dirigida pela Dra. Gilca Lucena Kortmann, a Clínica Mediação é referência em terapias integradas para bebês, crianças e adolescentes com patologias e transtornos de desenvolvimento e aprendizagem. Com uma trajetória marcada pela dedicação e excelência, a clínica se destaca no atendimento especializado e humanizado.
                                <br />
                                <br />
                                Fundadora
                                <br />
                                <br />
                                A Dra.  possui uma formação acadêmica sólida, incluindo doutorado e mestrado em educação, além de especializações em áreas como neuropsicologia e terapia de casal e família. Sua expertise abrange a estimulação precoce para bebês com patologias, bem como o atendimento a crianças e adolescentes com transtornos de desenvolvimento e aprendizagem. Além disso, Gilca integra o Grupo de Formação Avançada em Terapia Comportamental ABA no Autismo para Terapeutas, evidenciando seu compromisso com a atualização constante e o aprimoramento profissional.
                                <br />
                                <br />
                            </p>
                        </div>
                        <div className="introduction_gilca">
                        </div>
                        <div className="introduction_image_about">
                            <div className="gilca_image_wrapper">
                                <img className="img_gilca_about" src={gilcaImg} alt="Gilca Lucena" />
                                <div className="gilca_name_box">
                                    <h2 className="gilca_name">Dra. Gilca Lucena Kortmann</h2>
                                    <button className="curriculo_button" onClick={() => window.open("https://lattes.cnpq.br/9350331289823529", "_blank", "_noopener noreferrer")}>
                                        Currículo Lattes
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default History;